export var ProductCardChangeEvents;
(function (ProductCardChangeEvents) {
    ProductCardChangeEvents["Color"] = "COLOR";
    ProductCardChangeEvents["Attribute"] = "ATTRIBUTE";
    ProductCardChangeEvents["Selector"] = "SELECTOR";
})(ProductCardChangeEvents || (ProductCardChangeEvents = {}));
